import type { RecordView } from '@kit/sync/types/record-view';
import { Fragment, type ReactNode } from 'react';
import type { CollectionName } from './collection-name';
import { useRecord } from './use-record';

type RecordEditorProps<T> = {
  readonly collection: CollectionName;
  /** The ?edit= value: a record id, "new" or null. */
  readonly id: string | null;
  readonly children: (view: RecordView<T> | undefined) => ReactNode;
};

/** Renders the form for the record named by ?edit=, keyed by id so each record gets a fresh form. */
export function RecordEditor<T>({ collection, id, children }: RecordEditorProps<T>) {
  const isNew = id === 'new';
  const record = useRecord<T>(collection, id && !isNew ? id : undefined);
  if (!id) return null;
  if (isNew) return <Fragment key="new">{children(undefined)}</Fragment>;
  if (!record) return null;
  return <Fragment key={id}>{children(record)}</Fragment>;
}
